module.exports = __webpack_public_path__ + "static/media/Roboto-LightItalic.ac5bc917.woff";